import { render, staticRenderFns } from "./FormQuestionComment.vue?vue&type=template&id=2fc645dc&"
import script from "./FormQuestionComment.vue?vue&type=script&lang=js&"
export * from "./FormQuestionComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports